import React, { useState, useEffect } from 'react';
import { Truck, Tag } from 'lucide-react';
import Input from '../../components/forms/Input';
import Button from '../../components/ui/Button';

const VehiculoForm = ({ vehiculo, onSubmit, onCancel, isLoading, isEdit = false }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        placa: '',
        activo: 1
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEdit && vehiculo) {
            setFormData({
                nombre: vehiculo.nombre || '',
                placa: vehiculo.placa || '',
                activo: vehiculo.activo ? 1 : 0
            });
        }
    }, [isEdit, vehiculo]);

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));

        // Limpiar error del campo
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombre.trim()) {
            newErrors.nombre = 'El nombre del vehículo es requerido';
        }

        if (!formData.placa.trim()) {
            newErrors.placa = 'La placa es requerida';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const dataToSubmit = {
            nombre: formData.nombre.trim(),
            placa: formData.placa.trim().toUpperCase(),
            activo: parseInt(formData.activo)
        };

        onSubmit(dataToSubmit);
    };

    return (
        <form onSubmit={handleSubmit} className="vehiculo-form">
            <div className="form-container">
                <div className="form-column">
                    <h3 className="column-title">
                        <Truck size={18} />
                        Información del Vehículo
                    </h3>

                    <div className="form-group">
                        <Input
                            label="Nombre del Vehículo"
                            type="text"
                            value={formData.nombre}
                            onChange={(e) => handleInputChange('nombre', e.target.value)}
                            error={errors.nombre}
                            icon={<Truck size={18} />}
                            placeholder="ej. Camioneta Toyota Hilux"
                            required
                            disabled={isLoading}
                            maxLength={100}
                        />
                    </div>

                    <div className="form-group">
                        <Input
                            label="Placa"
                            type="text"
                            value={formData.placa}
                            onChange={(e) => handleInputChange('placa', e.target.value.toUpperCase())}
                            error={errors.placa}
                            icon={<Tag size={18} />}
                            placeholder="ABC-123"
                            required
                            disabled={isLoading}
                            maxLength={20}
                        />
                    </div>

                    {isEdit && (
                        <div className="form-group">
                            <label className="form-label">Estado</label>
                            <select
                                value={formData.activo}
                                onChange={(e) => handleInputChange('activo', e.target.value)}
                                className="form-select"
                                disabled={isLoading}
                            >
                                <option value={1}>✅ Activo</option>
                                <option value={0}>❌ Inactivo</option>
                            </select>
                        </div>
                    )}
                </div>
            </div>

            {/* Botones de acción */}
            <div className="form-actions">
                <Button
                    type="button"
                    variant="secondary"
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    Cancelar
                </Button>

                <Button
                    type="submit"
                    loading={isLoading}
                    disabled={isLoading}
                >
                    {isEdit ? 'Actualizar Vehículo' : 'Registrar Vehículo'}
                </Button>
            </div>
        </form>
    );
};

export default VehiculoForm;